/**
 * ユーザーの preferredUsername を取得する
 */
export const getPreferredUsername = ({
  organizationId,
  employeeNumber,
}: {
  organizationId: string;
  employeeNumber: string;
}) => {
  // Cognito のユーザー名は小文字に変換されるので、ここで小文字に変換しておく
  return `${organizationId}_${employeeNumber}`.toLowerCase();
};
